import { AuthLogoutRequestAction } from "auth";
import { SubmitAppEndAction } from "routes/App/modules";
import { AcceptInviteAction, AcceptInviteEndAction } from "./AcceptInvite";
import { AddPaymentAccountToOrganizationAction, AddPaymentAccountToOrganizationEndAction } from "./AddPaymentAccount";
import {
    AddPublishingAccountToOrganizationAction,
    AddPublishingAccountToOrganizationEndAction
} from "./AddPublishingAccount";
import { AddUserToOrganizationAction, AddUserToOrganizationEndAction } from "./AddUserToOrganization";
import { CreateOrganizationAction, CreateOrganizationEndAction } from "./CreateOrganization";
import { DeletePendingUserAction, DeletePendingUserEndAction } from "./DeletePendingUser";
import { FetchAvailableAppsSummaryAction, FetchAvailableAppsSummaryEndAction } from "./FetchAvailableAppsSummary";
import { FetchOrganizationAction, FetchOrganizationEndAction } from "./FetchOrganization";
import { FetchOrganizationListAction, FetchOrganizationListEndAction } from "./FetchOrganizationList";
import {
    FetchOrganizationUserAnalyticsAction,
    FetchOrganizationUserAnalyticsEndAction
} from "./FetchOrganizationUserAnalytics";
import { FetchPaymentAccountSummaryAction, FetchPaymentAccountSummaryEndAction } from "./FetchPaymentAccountSummary";
import { FetchUsersOfOrganizationAction, FetchUsersOfOrganizationEndAction } from "./FetchUsersOfOrganization";
import { RemoveUserFromOrganizationAction, RemoveUserFromOrganizationEndAction } from "./RemoveUserFromOrganization";
import { SelectOrganizationAction } from "./SelectOrganization";
import { UpdateOrganizationAction, UpdateOrganizationEndAction } from "./UpdateOrganization";
import { UpdateUserRolesAction, UpdateUserRolesEndAction } from "./UpdateUserRoles";
import {
    UploadOrgIconAction,
    UploadOrgIconClearAction,
    UploadOrgIconFailureAction,
    UploadOrgIconSuccessAction
} from "./UploadOrganizationIcon";

export * from "./AcceptInvite";
export * from "./AddPaymentAccount";
export * from "./AddPublishingAccount";
export * from "./AddUserToOrganization";
export * from "./CreateOrganization";
export * from "./DeletePendingUser";
export * from "./DownloadIPRights";
export * from "./FetchAvailableAppsSummary";
export * from "./FetchOrganization";
export * from "./FetchOrganizationList";
export * from "./FetchOrganizationUserAnalytics";
export * from "./FetchPaymentAccountSummary";
export * from "./FetchUsersOfOrganization";
export * from "./RemoveUserFromOrganization";
export * from "./SelectOrganization";
export * from "./UpdateOrganization";
export * from "./UpdateUserRoles";
export * from "./UploadOrganizationIcon";

export type OrgActions =
    | AcceptInviteAction
    | AcceptInviteEndAction
    | AddPaymentAccountToOrganizationAction
    | AddPaymentAccountToOrganizationEndAction
    | AddPublishingAccountToOrganizationAction
    | AddPublishingAccountToOrganizationEndAction
    | AddUserToOrganizationAction
    | AddUserToOrganizationEndAction
    | AuthLogoutRequestAction
    | CreateOrganizationAction
    | CreateOrganizationEndAction
    | DeletePendingUserAction
    | DeletePendingUserEndAction
    | FetchAvailableAppsSummaryAction
    | FetchAvailableAppsSummaryEndAction
    | FetchOrganizationAction
    | FetchOrganizationEndAction
    | FetchOrganizationListAction
    | FetchOrganizationListEndAction
    | FetchPaymentAccountSummaryAction
    | FetchPaymentAccountSummaryEndAction
    | FetchOrganizationUserAnalyticsAction
    | FetchOrganizationUserAnalyticsEndAction
    | FetchUsersOfOrganizationAction
    | FetchUsersOfOrganizationEndAction
    | RemoveUserFromOrganizationAction
    | RemoveUserFromOrganizationEndAction
    | SelectOrganizationAction
    | SubmitAppEndAction
    | UpdateOrganizationAction
    | UpdateOrganizationEndAction
    | UpdateUserRolesAction
    | UpdateUserRolesEndAction
    | UploadOrgIconAction
    | UploadOrgIconFailureAction
    | UploadOrgIconSuccessAction
    | UploadOrgIconClearAction;
